import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from "../../_services/api.integration";
import { Globals } from "../../_models/globals";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { User } from "../../_models/user";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-edit-address',
  templateUrl: './edit-address.component.html',
  styleUrls: ['./edit-address.component.css']
})
export class EditAddressComponent implements OnInit {
  address: any = {
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    geoCode: ""
  };
  addressT: string;
  addressType: any = [];
  statusText1: string = '';
  address1ErrorMessage: string;
  cityErrorMessage: string;
  stateErrorMessage: string;
  zipErrorMessage: string;
  statesList: any;
  citiesList: any;

  constructor(private alertService: AlertService, private api: ApiIntegration, private g: Globals, public route: ActivatedRoute, public router: Router, private http: HttpClient, private user: User) {
    this.g.page = "Edit Address";
    this.stateList();
    this.cityList();
    this.api.getAddressById(this.route.snapshot.params['addressId'], this.user.organizationId).subscribe((data: any) => {
      this.address = data;
      this.addressT = this.address.addressType
    }, err => {
      this.alertService.error('Error', err);
    });
    this.api.getValues("1", "ADDRESS_TYPE", "ADDRESS_TYPE", "ADDRESS_TYPE").subscribe((data: any) => {
      this.addressType = data.tripleSetConfigDTOS;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ChangeCityAndState() {
    this.api.getCityAndStateByPinCode(this.address.zip).subscribe((data: any) => {
      this.address.city = data.city;
      this.address.state = data.state;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit() {
  }

  typeAddress() {
    this.address1ErrorMessage = "";
    if (this.address.address1 == '' || this.address.address1 == null || this.address.address1 == undefined || this.address.address1 == 'undefined') {
      this.address1ErrorMessage = 'please enter address1';
    }
  }

  typeCity() {
    this.cityErrorMessage = "";
    if (this.address.city == '' || this.address.city == null || this.address.city == undefined || this.address.city == 'undefined') {
      this.cityErrorMessage = 'please enter city';
    }
  }

  typeState() {
    this.stateErrorMessage = "";
    if (this.address.state == '' || this.address.state == null || this.address.state == undefined || this.address.state == 'undefined') {
      this.stateErrorMessage = 'please enter state';
    }
  }

  typeZip() {
    this.zipErrorMessage = "";
    if (this.address.zip == '' || this.address.zip == null || this.address.zip == undefined || this.address.zip == 'undefined') {
      this.zipErrorMessage = 'please enter zip';
    }
  }

  editAddress() {
    this.g.loaderDisplay = "display";
    this.address1ErrorMessage = "";
    this.cityErrorMessage = "";
    this.stateErrorMessage = "";
    this.zipErrorMessage = "";

    if (this.address.address1 == '' || this.address.address1 == null || this.address.address1 == undefined || this.address.address1 == 'undefined') {
      this.address1ErrorMessage = 'please enter address1';
    }
    if (this.address.city == '' || this.address.city == null || this.address.city == undefined || this.address.city == 'undefined') {
      this.cityErrorMessage = 'please enter city';
    }
    if (this.address.state == '' || this.address.state == null || this.address.state == undefined || this.address.state == 'undefined') {
      this.stateErrorMessage = 'please enter state';
    }
    if (this.address.zip == '' || this.address.zip == null || this.address.zip == undefined || this.address.zip == 'undefined') {
      this.zipErrorMessage = 'please enter zip';
    }

    if (this.address1ErrorMessage != "" || this.cityErrorMessage != "" || this.stateErrorMessage != "" || this.zipErrorMessage != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createAddress', {
      "accountOwnerId": this.user.accountOwnerId,
      "address1": this.address.address1,
      "address2": this.address.address2,
      "addressType": this.addressT,
      "city": this.address.city,
      "organizationId": 1,
      "state": this.address.state,
      "zip": this.address.zip,
      "geoCode": this.address.geoCode,
      "status": this.address.status,
      "id": this.route.snapshot.params['addressId'],

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";

        if (data['code'] == 200) {
          this.alertService.success('Address', 'Edited Successfully');

          this.router.navigate(['/admin/myAccountList']);
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

        });
  }
}
